import React, { useCallback, useState } from "react";
import {
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { validateRequired } from "../../utils/Validations";

const useStyles = makeStyles(() => ({
    root: {
        width: "90%",
        margin: "auto"
    },
    warnLabel: {
        fontSize: "10px",
        color: "red",
        display: "block"
    },
}));

const ParentCategoryCreate = props => {
    const classes = useStyles();
    const [checked, setChecked] = useState(false);
    const handleChange = useCallback(newChecked => setChecked(newChecked), []);

    return (
        <Create {...props}>
            <SimpleForm redirect="list">
                <Grid container spacing={2} className={classes.root} justify="space-between">
                    <Grid item xs={6}>
                        <TextInput source="name" validate={validateRequired} label="Category Name" />
                    </Grid>
                    <Grid item xs={6}>
                        <TextInput source="sku_code" validate={validateRequired} label="SKU Code" />
                    </Grid>
                    <Grid item xs={6}>
                        <BooleanInput
                            label={checked ? "Active" : "Inactive"}
                            source="active"
                            initialValue={0}
                            onChange={handleChange}
                            checked={checked}
                            parse={v => (v ? 1 : 0)}
                        />
                    </Grid>
                </Grid>
            </SimpleForm>
        </Create>
    );
};

export default ParentCategoryCreate;
